<template>
  <section class="section">
    <!-- Table -->
    <table-ag
      ref="tableEmployeesCl7"
      :row-data="employees"
      :column-defs="columns"
      :components="components"
      :component-menu="componentMenu"
      :actions="true"
      :pagination="false"
      :auto-height="true"
    ></table-ag>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import tableAg from "../dashboard/tableAg.vue";
import MenuTableSurvey from "./components/menuTableSurvey.vue";
import ButtonsActionSurvey from "./components/ButtonsActionSurvey.vue";
import { buildTag } from "./helpers";
import { MAILJET_STATUS_CONFIG, STATUS_CONFIG } from "./helpers/constants";

export default {
  data() {
    return {
      employees: [],
      columns: [
        {
          field: "status",
          headerName: "Encuesta",
          width: 90,
          cellRenderer: (params) => {
            return this.formatStatus(params);
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          },
          editable: false,
        },
        {
          field: "nombre",
          headerName: "Nombre",
          tooltipValueGetter: (params) => {
            return params.value;
          },
          editable: false,
          def: true,
        },
        {
          field: "cedula",
          headerName: "Cédula",
          editable: false,
          def: true,
        },
        {
          field: "email",
          headerName: "Correo",
          editable: false,
          def: true,
        },
        {
          field: "mailRecord.status",
          headerName: "",
          width: 100,
          cellClass: "mailjet-status-cell",
          cellRenderer: (params) => {
            return this.formatStatusMailjet(params);
          },
          tooltipValueGetter: (params) => {
            if (!params.value) return "";
            const v = params.value.toLowerCase() || "";
            const key = v.startsWith("bounce") ? v.replace(" ", "_") : v;
            const config = MAILJET_STATUS_CONFIG[key];
            if (!config) return "";
            return JSON.stringify({
              label: config.label,
              desc: config.tooltip || "",
            });
          },
          tooltipComponent: "StatusTooltipCl7",
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          },
          editable: false,
        },
        {
          field: "_id",
          headerName: "Controles",
          colId: "_actions",
          editable: false,
          def: true,
          cellRenderer: "ButtonsActionSurveyCl7",
          sortable: false,
          width: 220,
        },
      ],
      componentMenu: () => {
        return {
          render: (h) =>
            h(MenuTableSurvey, {
              props: {
                employees: this.employees,
                proceso: this.proceso,
              },
              on: {
                updateProcess: this.updateProcess,
                calculateAll: this.calculateAll,
                getEmployees: this.getEmployees,
                refresh: this.refreshAll,
              },
            }),
        };
      },
      components: {
        ButtonsActionSurveyCl7: () => {
          return {
            render: (h) =>
              h(ButtonsActionSurvey, {
                props: {
                  proceso: this.proceso,
                },
                on: {
                  getEmployees: this.getEmployees,
                },
              }),
          };
        },
        StatusTooltipCl7: () => ({
          template: `
            <div class="status-tooltip">
              <div class="status-tooltip__label"><strong>{{ label }}</strong></div>
              <div v-if="desc" class="status-tooltip__desc">{{ desc }}</div>
            </div>
          `,
          computed: {
            parsed() {
              try {
                return JSON.parse(this.params.value || "{}");
              } catch (e) {
                return { label: this.params.value || "", desc: "" };
              }
            },
            label() {
              return this.parsed.label;
            },
            desc() {
              return this.parsed.desc;
            },
          },
        }),
      },
    };
  },
  props: {
    proceso: Object,
  },
  computed: {},
  beforeMount() {},
  methods: {
    // Table
    async getEmployees() {
      try {
        const result = await apiServices.get(
          `/employeesclima/${this.proceso._id}`,
        );
        if (result.data) {
          this.employees = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async calculateAll() {
      try {
        await apiServices.post(`/calculateallemployeeclima`, {
          proceso: this.proceso._id,
        });
        await this.getEmployees();
      } catch (err) {
        console.log(err);
      }
    },
    async refreshAll() {
      try {
        // Reload process to get updated reminder50SentAt
        const result = await apiServices.get(
          "/findcohorteclimacliente/" + this.proceso._id
        );
        if (result.data) {
          this.$emit("selproceso", result.data, {});
        }
        // Reload employees
        await this.getEmployees();
      } catch (err) {
        console.log(err);
      }
    },
    // Actions
    updateProcess(data) {
      if (data) this.$emit("selproceso", data, {});
    },
    // Others
    formatStatus(p) {
      if (
        p.data.responses &&
        !p.data.responses.agree &&
        ["Calculado"].includes(p.value.toLowerCase())
      ) {
        return buildTag({ tag: "is-info", label: "Desacuerdo" });
      }

      const config = STATUS_CONFIG[p.value.toLowerCase()];
      return config ? buildTag(config) : p.value;
    },
    formatStatusMailjet(p) {
      const buildEllipsisTag = ({ tag, label }) =>
        `<span class="tag ${tag} is-capitalized" style="width:100%"><span class="ellipsis-label">${label}</span></span>`;

      if (!p.value || !p.value.length) {
        return buildEllipsisTag({ tag: "is-grey", label: "Sin estado" });
      }

      const v = p.value.toLowerCase();

      if (v.startsWith("bounce")) {
        const key = v.replace(" ", "_");
        return buildEllipsisTag(
          MAILJET_STATUS_CONFIG[key] || MAILJET_STATUS_CONFIG["bounce_soft"],
        );
      }

      const config = MAILJET_STATUS_CONFIG[v];
      return config ? buildEllipsisTag(config) : p.value;
    },
  },
  created() {
    this.calculateAll();
  },
  watch: {},
  components: { tableAg },
};
</script>
<style lang="scss">
.ag-pre-table .ag-header-cell-label {
  justify-content: center !important;
}
.mailjet-status-cell .tag {
  max-width: 100%;
  min-width: 0;
}
.mailjet-status-cell .tag .ellipsis-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  display: block;
}
.status-tooltip {
  max-width: 260px;
  background-color: #2b2b2b;
  color: #fff;
  border: 1px solid #6b2fae;
  border-radius: 8px;
  padding: 0.4rem 0.7rem;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  font-size: 0.8rem;
  line-height: 1.35;
}
.status-tooltip__label {
  margin-bottom: 4px;
}
.status-tooltip__label strong {
  color: #fff;
}
.status-tooltip__desc {
  font-weight: normal;
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/Surveys.vue